jQuery(document).ready(function ($) {
    $('.m-donate-notice__close').on("click", function () {
        $('.m-donate-notice').hide(); 
        $('.layout-container').addClass('notice-closed');
    });
});
